module.exports = __webpack_public_path__ + "static/media/logo.15923944.png";